var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMark2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 217 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.547 56.978C45.657 58.76 42.957 60.191 39.447 61.271C35.991 62.297 32.4 62.81 28.674 62.81C21.06 62.81 14.769 60.353 9.801 55.439C4.887 50.471 2.43 44.099 2.43 36.323C2.43 31.949 3.348 27.629 5.184 23.363C7.02 19.097 9.882 15.56 13.77 12.752C17.658 9.944 22.626 8.54 28.674 8.54C33.102 8.54 36.882 9.161 40.014 10.403C43.146 11.645 45.63 13.103 47.466 14.777L48.843 26.198L41.472 26.927L40.176 19.637C36.936 17.531 33.048 16.478 28.512 16.478C23.544 16.478 19.548 18.206 16.524 21.662C13.554 25.118 12.069 29.843 12.069 35.837C12.069 42.101 13.662 46.853 16.848 50.093C20.034 53.279 24.219 54.872 29.403 54.872C33.723 54.872 37.26 54.116 40.014 52.604L41.31 44.747L48.681 45.476L47.547 56.978ZM99.916 56.978C98.026 58.76 95.326 60.191 91.816 61.271C88.36 62.297 84.769 62.81 81.043 62.81C73.429 62.81 67.138 60.353 62.17 55.439C57.256 50.471 54.799 44.099 54.799 36.323C54.799 31.949 55.717 27.629 57.553 23.363C59.389 19.097 62.251 15.56 66.139 12.752C70.027 9.944 74.995 8.54 81.043 8.54C85.471 8.54 89.251 9.161 92.383 10.403C95.515 11.645 97.999 13.103 99.835 14.777L101.212 26.198L93.841 26.927L92.545 19.637C89.305 17.531 85.417 16.478 80.881 16.478C75.913 16.478 71.917 18.206 68.893 21.662C65.923 25.118 64.438 29.843 64.438 35.837C64.438 42.101 66.031 46.853 69.217 50.093C72.403 53.279 76.588 54.872 81.772 54.872C86.092 54.872 89.629 54.116 92.383 52.604L93.679 44.747L101.05 45.476L99.916 56.978ZM154.796 26.522L147.02 27.17L145.4 17.045H135.113V54.305H143.942V62H117.617V54.305H126.122V17.045H115.754L114.134 27.17L106.439 26.522L108.059 9.35H153.176L154.796 26.522Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.977 61.0318L185.87 54.7151L193.077 49.3298L196.42 60.6957C196.497 60.9581 196.209 61.1768 195.977 61.0318ZM192.347 49.1329L185.641 54.1434V49.1329H192.347ZM192.265 48.538H185.641V44.0935L192.265 48.538ZM192.724 48.13L185.878 43.5357L190.467 40.456L192.724 48.13ZM185.047 49.1329V54.1434L178.341 49.1329H185.047ZM177.611 49.3298L184.818 54.7151L174.711 61.0318C174.479 61.1768 174.191 60.9581 174.268 60.6957L177.611 49.3298ZM185.047 48.538H178.423L185.047 44.0935V48.538ZM190.151 39.9518L185.641 42.9779V36.0001L190.151 39.9518ZM190.064 39.0843L185.795 35.344L188.314 33.1366L190.064 39.0843ZM188.129 32.5078L185.641 34.6879V24.0488L188.129 32.5078ZM177.964 48.13L180.221 40.456L184.81 43.5357L177.964 48.13ZM180.537 39.9518L185.047 36.0001V42.9779L180.537 39.9518ZM184.893 35.344L180.624 39.0843L182.374 33.1366L184.893 35.344ZM185.047 34.6879L182.559 32.5078L185.047 24.0488V34.6879Z",
    stroke: "#342F2F",
    strokeWidth: 0.594872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.258 39.0979H186.841L186.172 26.9154H183.926L183.258 39.0979Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.716617,
    height: 6.44955,
    transform: "matrix(1 0 0 -1 184.714 29.4952)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84 9H183.257L183.926 21.1825H186.172L186.84 9Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.716617,
    height: 6.44955,
    transform: "matrix(-1 0 0 1 185.407 18.316)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 25.8405V22.2574L182.182 22.9262V25.1716L170 25.8405Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.603,
    y: 24.3834,
    width: 0.716617,
    height: 6.44955,
    transform: "rotate(-90 179.603 24.3834)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.098 22.2574V25.8405L187.915 25.1717V22.9263L200.098 22.2574Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.782,
    y: 23.6906,
    width: 0.716617,
    height: 6.44955,
    transform: "rotate(90 190.782 23.6906)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.186 33.125L198.978 30.0219L188.093 24.5099L186.97 26.4545L197.186 33.125Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.716617,
    height: 6.44955,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 189.598 27.0617)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.912 14.973L171.12 18.076L182.005 23.588L183.128 21.6434L172.912 14.973Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.716617,
    height: 6.44955,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 180.263 20.8722)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.912 33.125L171.12 30.0219L182.005 24.5099L183.128 26.4545L172.912 33.125Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 27.0617,
    width: 0.716617,
    height: 6.44955,
    transform: "rotate(-120 180.5 27.0617)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.186 14.973L198.978 18.076L188.093 23.588L186.97 21.6434L197.186 14.973Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.835,
    y: 20.8722,
    width: 0.716617,
    height: 6.44955,
    transform: "rotate(60 189.835 20.8722)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.022 37.9775L194.125 36.186L187.454 25.9701L185.51 27.0927L191.022 37.9775Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.716617,
    height: 6.44955,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 187.482 28.9328)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.076 10.1204L175.973 11.912L182.643 22.1279L184.588 21.0052L179.076 10.1204Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.716617,
    height: 6.44955,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 182.493 18.9049)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.076 37.9775L175.973 36.186L182.643 25.9701L184.588 27.0927L179.076 37.9775Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.615,
    y: 28.9328,
    width: 0.716617,
    height: 6.44955,
    transform: "rotate(-150 182.615 28.9328)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.022 10.1204L194.125 11.912L187.455 22.1279L185.51 21.0052L191.022 10.1204Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.605,
    y: 18.9049,
    width: 0.716617,
    height: 6.44955,
    transform: "rotate(30 187.605 18.9049)",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.754,
    y: 23.7539,
    width: 21.2456,
    height: 0.590155,
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.819 20.8031L216.622 19.6228L214.557 23.1637L216.622 26.9997L204.819 26.1145V20.8031Z",
    fill: "#342F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark2);
export default __webpack_public_path__ + "static/media/mark-2.61251b73.svg";
export { ForwardRef as ReactComponent };